import { Region } from 'region-shortcut';

export const formRegion = new Region('form');



// WEBPACK FOOTER //
// ./src/shared/regionForm.js